// extracted by mini-css-extract-plugin
export var bg = "HeadingWithForm-module--bg--c0ebb";
export var container = "HeadingWithForm-module--container--412ca";
export var excerpt = "HeadingWithForm-module--excerpt--6ee21";
export var expand = "HeadingWithForm-module--expand--5e689";
export var form = "HeadingWithForm-module--form--57189";
export var gatedH1 = "HeadingWithForm-module--gated-h1--f3d38";
export var heading = "HeadingWithForm-module--heading--46700";
export var heroImage = "HeadingWithForm-module--hero-image--4adeb";
export var lightFont = "HeadingWithForm-module--light-font--5eee9";
export var nav = "HeadingWithForm-module--nav--0fec1";
export var sparkAwards = "HeadingWithForm-module--spark-awards--5d020";
export var sparkHeader = "HeadingWithForm-module--spark-header--aea94";
export var superText = "HeadingWithForm-module--super-text--f3ab8";